export default __webpack_public_path__ + "static/media/broad.53e044c9.png";